<template>
  <div class="cjd">
    <h3>信用培训成绩单</h3>
    <p>考试日期：{{cj.ksSj.substr(0,10)}}</p>
    <div class="solid">
			<img style="display: block;width: 100%;" src="/static/images/new/ks_top.png" alt="">
		</div>
    <table>
      <tbody>
      <tr>
        <td>考生姓名</td>
        <td>{{cj.pxrXm}}</td>
      </tr>
      <tr>
        <th>身份证</th>
        <th>{{cj.pxrSfz}}</th>
      </tr>
      <tr>
        <td>单位名称</td>
        <td>{{cj.qyMc}}</td>
      </tr>
      <tr>
        <th>培训内容</th>
        <th>{{cj.lxName}}</th>
      </tr>
      <tr>
        <td>成绩</td>
        <td>
          <span :class=" { 'red' : cj.ksCj < 85 } ">
            {{cj.ksCj}}
          </span>
        </td>
      </tr>
      <tr>
        <th>培训决定</th>
        <th>
          <span v-if="cj.ksCj >= 85">成绩达标，给予通过</span>
          <span v-else class="red">成绩不合格，不予通过</span>
        </th>
      </tr>
      </tbody>
    </table>
    <div class="gz">
      <img src="/static/images/gz.png" width="100%">
    </div>
  </div>
</template>

<script>
  export default {
    name: "cjd",
    props: ['cj']
  }
</script>

<style scoped lang="less" type="text/less">
  .cjd {
    padding: 45px 100px;
	width: 760px;
	height: 552px;
	position: relative;
    background: url("/static/images/muban_bg.png") repeat;
    h3{
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 32px;
      color: #06103b;
    }
    p{
      height: 42px;
      line-height: 42px;
      text-align: right;
      font-size: 16px;
      color: #06103b;
      // border-bottom: 1px solid #1b1b1b;
    }
    .solid{
      // height: 4px;
      // border-bottom: 1px solid #1b1b1b;
    }
    table{
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
    }
    table th ,table td{
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #06103b;
      padding-left: 60px;
      text-align: left;
    }
    table td .red,table th .red{
      color: red;
    }
    table th{
      font-weight: normal;
      background: rgba(0,0,0,0.05);
    }
    .gz{
	  width: 125px;
	  height: 124px;
      position: absolute;
      z-index: 1;
      right: 300px;
      bottom: 100px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/exam/cjd.vue